import * as React from "react";
import type { SADataKind } from "@/data/sellerAnalysisTypes";
import { cn } from "@/lib/utils";

const STYLES: Record<SADataKind, string> = {
  fact: "border border-charcoal/25 text-charcoal-muted",
  calculation: "border border-brass text-brass",
  interpretation: "bg-charcoal text-ivory",
};

const LABELS: Record<SADataKind, string> = {
  fact: "Fact",
  calculation: "Calculation",
  interpretation: "Interpretation",
};

interface Props {
  kind: SADataKind;
  children?: React.ReactNode;
  className?: string;
}

// Visually separates verified facts, deterministic calculations and
// interpretation/opinion — a core trust requirement of the presentation.
export const DataTag: React.FC<Props> = ({ kind, children, className }) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-1 text-[0.6rem] font-medium uppercase tracking-[0.2em]",
      STYLES[kind],
      className,
    )}
    data-testid={`data-tag-${kind}`}
  >
    {children || LABELS[kind]}
  </span>
);

export const DataLegend: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("flex flex-wrap items-center gap-2", className)}>
    <span className="mr-1 text-[0.65rem] uppercase tracking-[0.18em] text-charcoal-muted">
      How to read this:
    </span>
    <DataTag kind="fact" />
    <DataTag kind="calculation" />
    <DataTag kind="interpretation" />
  </div>
);
